import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute, ParamMap } from "@angular/router";
import { Observable } from "rxjs";
import { AsyncPipe } from "@angular/common";

@Component({
	selector: "stages-error-message",
	templateUrl: "error-message.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [AsyncPipe],
})
export class ErrorMessageComponent {
	paramMap$: Observable<ParamMap>;

	constructor() {
		const route = inject(ActivatedRoute);

		this.paramMap$ = route.paramMap;
	}
}
